import { useState } from 'react'
import { activateAccount } from '~/src/services/CustomerService'
import { useRouterPush } from '~/src/hooks/router/useRouterPush'
import { useFirmPathResolver } from '~/src/hooks/router/useFirmPathResolver'
import RoutesEnum from '~/src/router/enums/routes.enum'
import { useSnackbar } from 'notistack'
import { useTranslations } from '~/src/hooks/useTranslations'
import { ActivateAccountPayload, BasicResponse, HttpErrorMessageType } from '@eo-storefronts/eo-core'

interface ReturnsType {
  activateAccount(payload: ActivateAccountPayload): Promise<BasicResponse | undefined>,
  errors: Record<string, HttpErrorMessageType[]> | string | null,
  loading: boolean,
}

const useActivateAccount = (): ReturnsType => {
  const [ errors, setErrors ] = useState<Record<string, HttpErrorMessageType[]> | string | null>(null)
  const [ loading, setLoading ] = useState<boolean>(false)
  const { t } = useTranslations()
  const { enqueueSnackbar } = useSnackbar()
  const { push } = useRouterPush()
  const { resolve } = useFirmPathResolver()

  const activeAccount = async (payload: ActivateAccountPayload): Promise<BasicResponse | undefined> => {
    setErrors(null)
    setLoading(true)

    try {
      const response: BasicResponse = await activateAccount(payload)

      if (!response) {
        return
      }

      push(resolve(RoutesEnum.FIRM_HOME))

      return response
    } catch {
      setErrors(t('errors.confirmationCode'))
      enqueueSnackbar(t('errors.defaultError'), { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return { activateAccount: activeAccount, errors, loading }
}

export {
  useActivateAccount
}
